import React from "react";
import { Form } from "antd";
import NumInput from "../../../components/inputs/NumInput";

export default function FeaturesSection() {
  return (
    <>
      <Form.Item label="Жилийн хураамж (₮)" name="annualFee">
        <NumInput min={0} placeholder="0" />
      </Form.Item>

      <Form.Item label="Захиалгын хураамж (₮)" name="orderFee">
        <NumInput min={0} placeholder="0" />
      </Form.Item>

      <Form.Item label="Хугацаа (сар)" name="duration">
        <NumInput min={1} placeholder="24" />
      </Form.Item>
    </>
  );
}
